import { render, staticRenderFns } from "./headerdate.vue?vue&type=template&id=67ed9086&scoped=true&"
import script from "./headerdate.vue?vue&type=script&lang=js&"
export * from "./headerdate.vue?vue&type=script&lang=js&"
import style0 from "./headerdate.vue?vue&type=style&index=0&id=67ed9086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed9086",
  null
  
)

export default component.exports